import { useState } from "react";

import { TimelineMode, timelineMode } from "@/components/TimelineModePicker/TimelineModePicker.decl";
import { TimelineModePicker } from "@/components/TimelineModePicker/TimelineModePicker";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function InteractiveCase() {
  const [mode, setMode] = useState<TimelineMode>(timelineMode.simple);

  return (
    <div className="flex items-center gap-4">
      <TimelineModePicker
        mode={mode}
        onClickSimple={() => setMode(timelineMode.simple)}
        onClickKaraoke={() => setMode(timelineMode.karaoke)}
        onClickSentiments={() => setMode(timelineMode.sentiments)}
      />
      <span className="text-muted-foreground text-xs">
        Open the menu and pick a view - current mode: <strong>{mode}</strong>
      </span>
    </div>
  );
}

function ModeCase({ mode }: { mode: TimelineMode }) {
  return (
    <div className="flex items-center gap-2">
      <TimelineModePicker
        mode={mode}
        onClickSimple={() => {}}
        onClickKaraoke={() => {}}
        onClickSentiments={() => {}}
      />
      <span className="text-muted-foreground text-xs">
        Trigger icon for the <strong>{mode}</strong> mode
      </span>
    </div>
  );
}

export function PlaygroundTimelineModePicker() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Interactive</PlaygroundSubSectionTitle>
        <InteractiveCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Trigger per mode</PlaygroundSubSectionTitle>
        <div className="flex flex-col gap-2">
          <ModeCase mode={timelineMode.simple} />
          <ModeCase mode={timelineMode.karaoke} />
          <ModeCase mode={timelineMode.sentiments} />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
